
export class FeatureNames {
  static EventTracking: string = "eventtracking";
}

export class Features {
  static FeatureIsActive = (featureName: string): boolean => {
    var featureIsActiveForClient = document.querySelector('html').hasAttribute(featureName);
    return featureIsActiveForClient;
  }
}



